import { render, staticRenderFns } from "./DialogTimeout.vue?vue&type=template&id=94f1932c&lang=pug"
import script from "./DialogTimeout.vue?vue&type=script&lang=js"
export * from "./DialogTimeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports